import React from 'react';
import { Alert, Box, Button, SpaceBetween } from '@cloudscape-design/components';

interface ErrorBoundaryState {
    error: Error | null;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
    state: ErrorBoundaryState = { error: null };

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('ErrorBoundary caught render error:', error, info);
    }

    private handleReload = () => {
        window.location.reload();
    };

    render() {
        const { error } = this.state;
        if (!error) {
            return this.props.children;
        }
        return (
            <Box padding="l">
                <SpaceBetween size="m">
                    <Alert type="error" header="Something went wrong">
                        {error.message || 'An unexpected error occurred while rendering this page.'}
                    </Alert>
                    <Button variant="primary" onClick={this.handleReload}>
                        Reload
                    </Button>
                </SpaceBetween>
            </Box>
        );
    }
}
